import classNames from "classnames";
import React, { useCallback, useEffect } from "react";
import styles from "./style.module.scss";
import { percentage } from "shared/utils/helpers";

interface Props extends React.HTMLProps<HTMLInputElement> {
  progress: number;
  disable?: boolean;
  isRightOriented?: boolean;
}

function Slider(props: Props) {
  const { disable, progress, isRightOriented, max } = props;
  const setRef = useCallback(
    (element: any) => {
      if (element) {
        element.onchange = props.onChange ? props.onChange : null;
        element.oninput = props.onInput ? props.onInput : null;
      }
    },
    [props.onChange]
  );

  useEffect(() => {
    // for show progress bar after change value
    // @ts-ignore
    if (document.getElementById("mySlider")) {
      // @ts-ignore
      document.getElementById("mySlider").oninput = function () {
        // @ts-ignore
        // var value = ((this.value - this.min) / (this.max - this.min)) * 100;
        var value = Math.trunc(percentage(this.value, max - 1));
        // @ts-ignore
        this.style.background =
          `linear-gradient(to ${
            isRightOriented ? "left" : "right"
          }, #ef437b 0%, #ef437b ` +
          value +
          "%, #D9E0E9 " +
          value +
          "%, #D9E0E9 100%)";
        // }
      };
    }
  }, []);

  useEffect(() => {
    // for show progress bar intially
    let ele: any = document.getElementById("mySlider");
    var value = 0;
    if (max) {
      value = Math.trunc(percentage(progress, Number(max)));
    }
    // @ts-ignore
    ele.style.background =
      `linear-gradient(to ${
        isRightOriented ? "left" : "right"
      }, #ef437b 0%, #ef437b ` +
      value +
      "%, #D9E0E9 " +
      value +
      "%, #D9E0E9 100%)";
  }, [progress]);

  return (
    <div
      className={classNames(
        "d-flex align-items-center",
        styles.progressContainer
      )}
    >
      <input
        ref={setRef}
        id="mySlider"
        min={0}
        max={max}
        disabled={disable}
        type="range"
        value={progress}
        onChange={() => {}}
        onInput={undefined}
        style={isRightOriented ? { direction: "rtl" } : {}}
      />
    </div>
  );
}

export default Slider;
